export default {
  data() {
    return {
      chartOptions: {
        chart: {
          backgroundColor: 'transparent',
          inverted: true,
          height: 680,
        },
        title: {
          text: '',
        },
        plotOptions: {
          organization: {
            linkColor: '#ffffff',
            linkLineWidth: 2,
            linkOpacity: 1,
            linkRadius: 20,
            nodePadding: 30,
            levels: [
              {level: 0},
              {level: 1},
              {level: 2},
            ],
            events: {
              click: (event) => {
                this.selectedNode = {
                  id: event.point.id,
                  name: event.point.name === 'Click to complete' ? '' : event.point.name,
                  linksTo: {from: event.point.linksTo[0].from},
                  linksFrom: event.point.linksFrom.map(({to}) => to),
                  is_hanging: !!event.point.hangsFrom,
                };

                this.menu = false;
                this.menuX = event.clientX - event.offsetX;
                this.menuY = event.clientY - event.offsetY;

                setTimeout(() => {
                  if (this.$refs['nodeForm']) {
                    this.$refs.nodeForm.resetValidation();
                  }
                  this.menu = true;
                }, 0);
              }
            },
          }
        },
        series: [
          {
            type: 'organization',
            keys: ['from', 'to'],
            data: [],
            nodes: [],
            colorByPoint: false,
            color: '#1E3B5A',
            dataLabels: {
              color: 'white',
            },
            borderColor: 'white',
            borderRadius: 22,
            borderWidth: 3,
            nodeWidth: 65,
            linkRadius: 50,
            linkLineWidth: 3,
          }
        ],
        tooltip: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ['downloadPDF'],
            },
          },
          enabled: false,
          // allowHTML: true,
          // sourceWidth: 800,
          // sourceHeight: 600,
        }
      }
    }
  }
}